export enum SlotStatus {
  FUTURE = 'TODAY',
  PAST = 'PAST',
  NOW = 'NOW'
}